import axios from 'axios'
import { getTokenConfig } from '../../../../../src/auth'

const API_URL = process.env.REACT_APP_API_URL

/**
 * Valida el Excel de recargas (modo validación).
 */
export const uploadRechargeExcel = async (file: File) => {
  const config = await getTokenConfig()
  const base64File = await toBase64(file)

  const url = `${API_URL}/rechargesInsert`

  const response = await axios.post(
    url,
    {
      fileName: file.name,
      fileType: file.type,
      fileContent: base64File,
    },
    {
      ...config,
      headers: {
        ...config.headers,
        'Content-Type': 'application/json',
      },
    }
  )

  return response.data
}

/**
 * Procesa (ALTA, EDITAR, ELIMINAR) las recargas validadas (modo registro).
 */
export const processRecharges = async (rows: any[]) => {
  const config = await getTokenConfig()
  const url = `${API_URL}/rechargesInsert`

  await axios.post(
    url,
    {
      type: 'bulk_update_recharges',
      data: rows,
    },
    {
      ...config,
      headers: {
        ...config.headers,
        'Content-Type': 'application/json',
      },
    }
  )
}

/**
 * Helper: convierte File a base64 (solo contenido)
 */
const toBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        const [, base64] = reader.result.split(',')
        resolve(base64)
      } else {
        reject(new Error('Formato inesperado al leer el archivo'))
      }
    }
    reader.onerror = (error) => reject(error)
  })
}
